/* eslint-disable no-unused-vars */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { 
    Row, 
    TitleSection } from "components/styles";
//#endregion
//#region Components
import PageManager from "../../../components/PageManager/PageManager";
import CaptionGroup from "../../../components/CaptionGroup/CaptionGroup";
//#endregion
import { getDatePartsByMillis, MONTHS } from "components/CustomDatePicker/utils/helpers";
import { getFormattedCaption } from "components/PageManager/utils";

const getDateText = date => {
    const dateParts = getDatePartsByMillis(date);
    const nowParts = getDatePartsByMillis(Date.now());
    const [_, monthNumber, dateNumber] = dateParts;
    const todayPrefix = dateParts.every((part, idx) => part === nowParts[idx]) ? "Hoy " : "";
    return `${todayPrefix}${dateNumber} de ${MONTHS[monthNumber].toLowerCase()}`;
}

const Header = ({ 
    date,
    dataPaginator
}) => {
    //#region States
    const [dateStr, setDateStr] = useState("-");
    //#endregion
    //#region Effects
    useEffect(() => {
        setDateStr(getDateText(date));
    }, [date]);
    //#endregion
    return (
        <Row width="100%" marginTop="35px">
            <TitleSection width="300px">{dateStr}</TitleSection>
            <CaptionGroup/>
            <PageManager 
                caption="Asesores"
                dataPaginator={{
                    ...dataPaginator,
                    formatted: getFormattedCaption(dataPaginator)
                }}/>
        </Row>
    );
}

export default Header;